import screenSizes from './screenSizes';
import scale from './typeScale';

export default {
  H1_HERO: {
    fontSize: scale.H1_HERO_DESKTOP,
    fontWeight: scale.H1_HERO_FONT_WEIGHT,
    lineHeight: scale.HEADER_LINE_HEIGHT,
    maxWidth: 700,

    [screenSizes.TABLET]: { fontSize: scale.H1_HERO_MOBILE },
    [screenSizes.DESKTOP_HD]: { fontSize: scale.H1_DESKTOP_HD },
  },

  H1: {
    fontSize: scale.H1_DESKTOP,
    fontWeight: scale.H1_FONT_WEIGHT,
    lineHeight: scale.LIST_ITEM_LINE_HEIGHT,
    marginBottom: scale.H1_DESKTOP_MB,
    maxWidth: 850,

    [screenSizes.TABLET]: { fontSize: scale.H1_MOBILE, marginBottom: scale.H1_TABLET_MB },
    [screenSizes.DESKTOP_HD]: { fontSize: scale.H1_DESKTOP_HD, marginBottom: scale.H1_DESKTOP_HD_MB  },
  },

  H2: {
    fontSize: scale.H2_DESKTOP,
    fontWeight: scale.H2_FONT_WEIGHT,
    lineHeight: scale.HEADER_LINE_HEIGHT,
    maxWidth: 700,

    [screenSizes.TABLET]: { fontSize: scale.H2_MOBILE },
    [screenSizes.DESKTOP_HD]: { fontSize: scale.H2_DESKTOP_HD },
  },

  H3: {
    fontSize: scale.H3_DESKTOP,
    fontWeight: scale.H3_FONT_WEIGHT,
    lineHeight: scale.HEADER_LINE_HEIGHT,
    marginBottom: scale.H3_DESKTOP_MB,
    maxWidth: 700,

    [screenSizes.TABLET]: { fontSize: scale.H3_MOBILE, marginBottom: scale.H3_TABLET_MB  },
    [screenSizes.DESKTOP_HD]: { fontSize: scale.H3_DESKTOP_HD, marginBottom: scale.H3_DESKTOP_HD_MB  },
  },

  H4: {
    fontSize: scale.H4_DESKTOP,
    fontWeight: scale.H4_FONT_WEIGHT,
    lineHeight: scale.HEADER_LINE_HEIGHT,
    maxWidth: 700,

    [screenSizes.TABLET]: { fontSize: scale.H4_MOBILE },
    [screenSizes.DESKTOP_HD]: { fontSize: scale.H4_DESKTOP_HD },
  },

  H5: {
    fontSize: scale.H5_DESKTOP,
    fontWeight: scale.H5_FONT_WEIGHT,
    lineHeight: scale.HEADER_LINE_HEIGHT,
    marginBottom: scale.H5_DESKTOP_MB,
    maxWidth: 700,

    [screenSizes.TABLET]: { fontSize: scale.H5_MOBILE, marginBottom: scale.H5_TABLET_MB },
    [screenSizes.DESKTOP_HD]: { fontSize: scale.H5_DESKTOP_HD, marginBottom: scale.H5_DESKTOP_HD_MB },
  },

  P: {
    fontSize: scale.P_DESKTOP,
    fontWeight: scale.P_FONT_WEIGHT,
    lineHeight: scale.PARAGRAPH_LINE_HEIGHT,
    maxWidth: 700,

    [screenSizes.TABLET]: { fontSize: scale.P_MOBILE },
    [screenSizes.DESKTOP_HD]: { fontSize: scale.P_DESKTOP_HD },
  },

  SMALL: {
    fontSize: scale.SMALL_MOBILE,
    fontWeight: scale.SMALL_FONT_WEIGHT,
    lineHeight: scale.LIST_ITEM_LINE_HEIGHT,

    [screenSizes.TABLET]: { fontSize: scale.SMALL_DESKTOP },
    [screenSizes.DESKTOP_HD]: { fontSize: scale.SMALL_DESKTOP_HD },
  },

  FOOTER: {
    fontSize: scale.H1_HERO_DESKTOP,
    fontWeight: scale.H4_FONT_WEIGHT,
    lineHeight: scale.HEADER_LINE_HEIGHT,

    [screenSizes.MOBILE]: { fontSize: '36px', marginBottom: '54px' },
    [screenSizes.DESKTOP_HD]: { fontSize: '66px', marginBottom: '66px' },
  },

  LABEL: { fontWeight: scale.SEMI_BOLD },
};



// WEBPACK FOOTER //
// ./src/identity/type.js